
import { ITree } from "./ITree"
import { Etap } from "./Etap"
import { ILbl } from "@/lbl/ILbl";
import { DateString } from "@/DateString";


export class Tree implements ITree {
    _id:string|undefined;
    type:string="tree";
    parent_id:string|undefined;
    parent_type:string|undefined;
    kalk_id:number=0
    fnd:string=""
    del:number=0

    stat={}
    etapy:Etap[]=[]
    surowce=[]
    lakiery=[]
    date_created=DateString.toISOString()
    date_modified=this.date_created;
    idn="Technologia: "+this.date_created
    zlecenie=""

    lbl: ILbl | undefined = undefined


    version: number=1
    _err: any = {}
    grupa_maszyn_arr: string[]=[];
    x:number=0
    y:number=0
    lbl_id: any | undefined = undefined
    // zlecenia kontrolne - test
    nr_zlecenia_ist:string|undefined=""; 
    grupa_maszyn_ist:string|undefined="";
    nakład_K_ist: number | undefined; 

    constructor(parent_type:string|undefined, parent_id:string|undefined) {
        this.parent_type=parent_type
        this.parent_id=parent_id
    }

}